import React, { useState, useEffect } from "react";
import "./Products.scss";
import ReactPaginate from "react-paginate";
import { BsFillStarFill } from "react-icons/bs";
import Countdown from "react-countdown";
import { ReactComponent as Featherclock } from "assets/images/featherclock.svg";
import { BsFillArrowUpCircleFill } from "react-icons/bs";
import { baseURL } from "constants/constants";
import { NavLink } from "react-router-dom";

const Products = ({ data }) => {
  const products = data;
  const [id, setId] = useState();
  const [page, setPage] = useState(0);
  const [DisplaIitem, setDisplaIitem] = useState("");
  const [open, setOpen] = useState(false);
  var intFrameWidth = window.innerWidth;
  var itemperPage = intFrameWidth < 450 ? 5 : 16;
  const pageVisited = page * itemperPage;
  const handleAccordion = (itemId) => {
    if (open) {
      setOpen(!open);
      if (itemId === id) {
        return null;
      }
    }
    setOpen((prevValue) => !prevValue);
    setId(itemId);
  };
  useEffect(() => {
    console.log(data, "data");
  }, [page]);

  const sortRange = (range = []) => {
    let Range = [...range];
    return Range.sort((a, b) => a["from_price"] - b["from_price"]);
  };
  const sortRange2 = (range = []) => {
    let Range = [...range];
    let item = Range.find((item) => item["is_active"] == 1);
    try {
      return item.from_price;
    } catch (error) {
      return "فروش تمام شد";
    }
    // return Range.find((item) => item["is_active"] == 1);
  };

  const returnProductItemBaseOnType = (item) => {
    if (item.range) {
      return (
        <div
          key={item.id}
          className="products card p-2 col-lg-3 col-md-4 col-sm-6 border-0 "
        >
          <div
            style={{ maxWidth: "250px" }}
            className={`product-wrapper  m-1 mx-auto pt-4`}
          >
            {open && item.id === id && item.countdown && (
              <div className="d-flex justify-content-center align-items-center mt-3 expanded-countdown pb-4">
                <Countdown daysInHours={true} date={item?.countdown} />
                <i className="me-2">
                  {<Featherclock className="expanded-clock" />}
                </i>
              </div>
            )}
            <div className="img-wrapper text-center">
              <img
                width={195}
                height={195}
                style={{ borderRadius: "10px" }}
                src={`http://marketgroup.tatdemo.ir/${
                  item.url.length > 0 ? item.url[0].url : ""
                }`}
                alt={item.title}
              />
            </div>

            <div
              className={`card-body m-2 ${
                open && item.id === id ? "d-none" : ""
              }`}
            >
              <div style={{ fontSize: 13 }} className="text-dark two-line">
                <span className="fw-bold">فروشگاه: &nbsp;</span>
                {item.businesses_type == "1"
                  ? item.businesses_title
                  : (item.businesses_id * 100) / 2}
                #
              </div>
              <div>
                <span title={item.title} className="  product-title">
                  {item.title}
                </span>
              </div>
              <div className="d-flex justify-content-center align-items-start flex-column text-right gap-2 mt-2">
                <span className="maxprice">
                  حداکثر قیمت:
                  {item.range &&
                    (
                      sortRange(item.range)[item.range.length - 1]?.from_price *
                      1
                    ).toLocaleString()}{" "}
                  تومان
                </span>

                <span className="text-danger minprice">
                  حداقل قیمت :
                  {(
                    item.range &&
                    (sortRange(item.range)[0]?.from_price * 1).toLocaleString()
                  ).toLocaleString()}
                  {/* {item.sold <= 100
                  ? item.price - item.price * 0.25
                  : item.sold <= 200 && item.sold > 100
                  ? item.price - item.price * 0.5
                  : item.sold > 200 && item.price - item.price * 0.5} */}
                  تومان
                </span>
              </div>
              <div
                id="accordionExample"
                className="d-flex justify-content-center align-items-center flex-column mt-3 text-center"
              >
                <button
                  onClick={() => handleAccordion(item.id)}
                  type="button"
                  className="morebutton px-4 py-2"
                >
                  بیشتر
                </button>
              </div>
            </div>
            {open && item.id === id ? (
              <div>
                <div className="accordion-body d-flex flex-column ">
                  <div style={{ fontSize: 13 }} className="text-dark two-line">
                    <span className="fw-bold">فروشگاه: &nbsp;</span>
                    {item.businesses_type == "1"
                      ? item.businesses_title
                      : `${(item.businesses_id * 100) / 2}#`}
                  </div>
                  <span className="text-center">{item.title}</span>

                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex justify-content-center align-items-center">
                      <span className="">قیمت : </span>
                      <span className=" text-secondary">
                        {(sortRange2(item.range) * 1).toLocaleString()}
                        {/* .from_price */}
                      </span>
                    </div>
                    <div>
                      <span className="expanded-discounted fw-bold">
                        {/* {item.sold <= 100
                        ? item.default_price - item.default_price * 0.25
                        : item.sold <= 200 && item.sold > 100
                        ? item.default_price - item.default_price * 0.5
                        : item.sold > 200 &&
                          item.default_price - item.default_price * 0.5} */}
                      </span>
                      <span className="expanded-discounted "> تومان</span>
                    </div>
                  </div>
                  {/* range starts here */}
                  <div className="">
                    {/* range item */}
                    {item.range.map((value) => {
                      return (
                        <>
                          <div
                            className={`d-flex justify-content-between align-items-center mt-4 ${
                              +value.is_active
                                ? "active-progress_active"
                                : "text-secondary opacity-50"
                            }`}
                          >
                            <span>({value.to_count})</span>
                            <span>({value.from_count})</span>
                          </div>
                          <div dir="ltr" className="progress my-1 bg-light">
                            <div
                              dir="ltr"
                              id="progress-bar"
                              className="progress-bar"
                              role="progressbar"
                              style={{
                                width: `${(
                                  (value.saled_count * 100) /
                                  value.to_count
                                ).toFixed(0)}% `,
                              }}
                            >
                              {value.saled_count}
                            </div>
                          </div>
                          <div
                            className={`d-flex justify-content-between align-items-center 
                ${
                  +value.is_active
                    ? "active-progress_price"
                    : "deactive-progress_price"
                }`}
                          >
                            <span>
                              {(value.to_price * 1).toLocaleString()} تومان
                            </span>
                            <span>
                              {(value.from_price * 1).toLocaleString()} تومان
                            </span>
                          </div>
                        </>
                      );
                    })}
                  </div>
                  {/* range ends here */}
                  <div className="d-flex justify-content-center">
                    <NavLink
                      to={`product/${item.product_id}/${item.businesses_id}/2`}
                      className="mx-auto "
                      target="_blank"
                    >
                      <button className="expanded-button shadow d-flex justify-content-center align-self-center align-items-center mt-4 text-light">
                        مشاهده محصول
                      </button>
                    </NavLink>
                  </div>
                  <i
                    onClick={() => setOpen(false)}
                    className="close-accordion mt-1 "
                  >
                    {<BsFillArrowUpCircleFill />}
                  </i>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div
          key={item.id}
          className=" products card p-2 col-lg-3 col-md-4 col-sm-6 border-0"
        >
          <div>
            <div
              style={{ maxWidth: "250px" }}
              className={`product-wrapper  m-1 ${
                open && item.id === id ? "pt-0" : "pt-4"
              }`}
            >
              <div className="img-wrapper text-center">
                <img
                  width={195}
                  height={195}
                  style={{ borderRadius: "10px" }}
                  src={`http://marketgroup.tatdemo.ir/${
                    item.url.length > 0 ? item.url[0].url : ""
                  }`}
                  alt={item.title}
                />
              </div>
              <div
                style={{ paddingBottom: "43px" }}
                className={`card-body m-2 ${
                  open && item.id === id ? "d-none" : ""
                }`}
              >
                <div style={{ fontSize: 13 }} className="text-dark two-line">
                  <span className="fw-bold">فروشگاه: &nbsp;</span>
                  {item.businesses_type == "1"
                    ? item.businesses_title
                    : `${(item.businesses_id * 100) / 2}#`}
                </div>
                <div>
                  <span title={item.title} className=" product-title">
                    {item.title}
                  </span>
                </div>
                <div className="d-flex justify-content-center align-items-start flex-column text-right gap-2 mt-2">
                  {/* <span className="text-dark minprice">
                    {item.businesseTitle[0].title}
                  </span> */}
                  <div className="d-flex justify-content-between align-items-start gap-4 mt-2">
                    <p className="maxprice text-danger text-decoration-line-through">
                      {/* قیمت اصلی: */}
                      {(item.main_price * 1).toLocaleString()}
                    </p>
                    <p className=" minprice">
                      {/* قیمت با تخفیف : */}
                      {(
                        (parseInt(item.main_price) -
                          parseInt(item.main_discount)) *
                        1
                      ).toLocaleString()}
                      تومان
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-center ">
                  <NavLink
                    target="_blank"
                    to={`product/${item.product_id}/${item.businesses_id}/1`}
                    className="mx-auto"
                  >
                    <button className="expanded-button shadow d-flex justify-content-center align-self-center align-items-center text-light">
                      مشاهده محصول
                    </button>
                  </NavLink>
                </div>
                {/* <div
                  id="accordionExample"
                  className="d-flex justify-content-center align-items-center flex-column mt-3 text-center"
                ></div> */}
              </div>
            </div>
          </div>
        </div>
      );
    }
  };
  // products.length>0 &&
  const displayItems = products
    .slice(pageVisited, pageVisited + itemperPage)
    .map((item) => {
      return returnProductItemBaseOnType(item);
    });
  const pageCount = Math.ceil(products.length / itemperPage);

  const handlePageClick = ({ selected }) => {
    setPage(selected);
  };

  return (
    <div className="mt-4 ">
      <div className="title d-flex flex-wrap justify-content-start fs-5">
        {/* <span className="mx-3">محصولات</span> */}
      </div>
      <div className="container-fluid  p-0">
        <div className="d-flex flex-wrap justify-content-evenly p-0 m-0 p-2 res-product">
          {displayItems.length > 0 && displayItems}
          {/* <ProductInfo data={data} /> */}
        </div>
        <div className="mx-auto mt-5" style={{ width: "fit-content" }}>
          <ReactPaginate
            breakLabel="..."
            nextLabel="بعدی"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="قبلی"
            renderOnZeroPageCount={null}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
          />
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default Products;
